export default "__VITE_ASSET__7e8b50da__"